import { HTMLAttributes, DetailedHTMLProps } from 'react';

type OptionalSectionProps = Pick<
  DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
  'className' | 'children' | 'id' | 'itemScope' | 'itemType'
> & { heading: string | undefined | boolean; dataTestId?: string };

export const OptionalSection = ({
  heading,
  children,
  className,
  id,
  itemScope,
  itemType,
  dataTestId = 'optional-section',
}: OptionalSectionProps) => {
  const Root = heading ? 'section' : 'div';

  return (
    <Root
      className={className}
      id={id}
      itemScope={itemScope}
      itemType={itemType}
      data-testid={dataTestId}
    >
      {children}
    </Root>
  );
};

export default OptionalSection;
